<template>
  <auth-layout>
    <h1 class="tn-auth__title">Welcome back</h1>
    <p class="tn-auth__subtitle">Sign in to the Tanefer admin console.</p>

    <v-alert v-if="error" type="error" text dense dismissible class="tn-auth__alert" @input="error = ''">
      {{ error }}
    </v-alert>

    <v-form ref="form" v-model="valid" class="tn-auth__fields" @submit.prevent="login">
      <label class="tn-field-label" for="login-email">Email</label>
      <v-text-field
        id="login-email"
        ref="emailField"
        v-model="email"
        type="email"
        outlined
        dense
        hide-details="auto"
        color="gold"
        placeholder="you@tanefer.com"
        prepend-inner-icon="mdi-email-outline"
        :rules="[v => !!v || 'Email is required', v => /.+@.+\..+/.test(v) || 'E-mail must be valid']"
        class="tn-auth-field"
      ></v-text-field>

      <div class="tn-field-row">
        <label class="tn-field-label" for="login-password">Password</label>
        <button type="button" class="tn-link-btn" @click="openForgot">Forgot password?</button>
      </div>
      <v-text-field
        id="login-password"
        v-model="password"
        :type="show ? 'text' : 'password'"
        outlined
        dense
        hide-details="auto"
        color="gold"
        placeholder="Your password"
        prepend-inner-icon="mdi-lock-outline"
        :append-icon="show ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
        @click:append="show = !show"
        :rules="[v => !!v || 'Password is required', v => v.length >= 8 || 'Password must be at least 8 characters']"
        autocomplete="off"
        class="tn-auth-field"
      ></v-text-field>

      <v-btn
        id="submit-btn"
        type="submit"
        color="navy"
        block
        large
        depressed
        class="tn-auth__submit"
        :loading="loading"
      >
        Sign in
        <v-icon right size="18" class="tn-auth__submit-arrow">mdi-arrow-right</v-icon>
      </v-btn>
    </v-form>

    <v-dialog v-model="dialog" max-width="420">
      <v-card>
        <v-card-title>
          Reset your password
          <v-spacer></v-spacer>
          <v-btn icon small aria-label="Close" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form1" v-model="valid1" @submit.prevent="send">
          <v-card-text class="pb-2">
            <p class="mb-4">Enter your email and we will send you a code to reset your password.</p>
            <v-alert v-if="forgotError" type="error" text dense class="mb-4">{{ forgotError }}</v-alert>
            <label class="tn-field-label" for="forgot-email">Email</label>
            <v-text-field
              id="forgot-email"
              v-model="email1"
              type="email"
              outlined
              dense
              hide-details="auto"
              color="gold"
              placeholder="you@tanefer.com"
              prepend-inner-icon="mdi-email-outline"
              :rules="[v => !!v || 'Email is required', v => /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(v) || 'E-mail must be valid']"
              autocomplete="off"
              class="tn-auth-field"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="px-6 pb-6 pt-4">
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false">Cancel</v-btn>
            <v-btn color="navy" class="white--text" depressed type="submit" :disabled="!valid1" :loading="loading1">Send code</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </auth-layout>
</template>

<script>
import AuthLayout from '../components/layout/AuthLayout.vue'
import { login, resetPasswordCode, headersNoAuth } from '../links'

export default {
  components: { AuthLayout },
  data () {
    return {
      valid: true,
      valid1: true,
      loading: false,
      loading1: false,
      error: '',
      forgotError: '',
      show: false,
      email: '',
      email1: '',
      password: '',
      dialog: false
    }
  },
  mounted () {
    // Programatically set autocomplete attribute to "new-password"
    this.$refs.emailField.$el.querySelector('input').setAttribute('autocomplete', 'new-password')

    const token = localStorage.getItem('token')
    const userTokenCookie = this.$cookies.get('userToken')
    if (token && userTokenCookie) {
      const decodedToken = JSON.parse(atob(token.split('.')[1])) // Decode the token
      // Get the expiration time (in seconds)
      const expirationTime = decodedToken.exp
      // Get the current time (in seconds)
      const currentTime = Math.floor(Date.now() / 1000)
      const isAuthenticated = token && currentTime < expirationTime && userTokenCookie
      if (isAuthenticated) {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  methods: {
    openForgot () {
      this.email1 = this.email
      this.forgotError = ''
      this.dialog = true
    },
    send () {
      if (!this.$refs.form1.validate()) return
      this.loading1 = true
      this.forgotError = ''
      this.$http.post(resetPasswordCode, { email: this.email1 }, { headers: headersNoAuth() }).then(response => {
        if (response.body.status === false) {
          this.forgotError = response.body.message
          this.loading1 = false
        } else {
          this.$router.push({ name: 'resetPassword', params: { email: this.email1 } })
        }
      }, () => {
        this.forgotError = 'Something went wrong please try again in few seconds'
        this.loading1 = false
      })
    },
    login () {
      if (this.loading) return
      if (!this.$refs.form.validate()) {
        this.error = 'Please fill all fields'
        return
      }
      this.loading = true
      this.error = ''
      const body = {
        email: this.email,
        password: this.password,
        role: 'admin'
      }
      this.$http.post(login, body, { headers: headersNoAuth() }).then(response => {
        this.loading = false
        if (response.body.status === true) {
          this.$store.dispatch('setUser', response.body.data.user)
          this.$cookies.set('userToken', response.body.data.token.access_token, response.body.data.token.expires_in)
          localStorage.setItem('userRoles', response.body.data.user.role.split(','))
          localStorage.setItem('token', response.body.data.token.access_token)
          setTimeout(() => {
            this.$cookies.remove('userToken')
            this.$store.dispatch('removeUser')
            localStorage.removeItem('token')
            this.$router.push({ name: 'login' })
          }, response.body.data.token.expires_in * 1000)
          const redirect = this.$route.query.redirect
          if (typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//')) this.$router.push(redirect)
          else this.$router.push({ name: 'Home' })
        } else {
          this.error = response.body.message
        }
      }, () => {
        this.loading = false
        this.error = 'Something went wrong please try again in few seconds'
      })
    }
  }
}
</script>
